import {createImageUrl, insertImageValue} from '/set_pics_functions/set_pic_functions.js';

const methods = {
    'YT_URL' : youtubeMethodInit,
    'SCL_URL' : soundCloudMethodInit,
    'PIC_FILE' : imageFileMethodInit,
    'IDEA' : ideaMethodInit
}

export function createPreview(preview, onLoadedFunction=null) {

    const method = preview.method;

    console.log("preview ", preview);

    const methodFunction = methods[method];

    if(methodFunction instanceof Function)
        return methodFunction(preview, onLoadedFunction);
    else
        throw new Error("invalid preview function!");
}

function ideaMethodInit(preview, onLoadedFunction) {
    const previewContent = document.createElement('div');
    previewContent.classList.add("idea-preview-content");

    const previewContentImageBox = document.createElement('div');
    previewContentImageBox.classList.add("idea-preview-content-image-box");

    const lightbulb = document.createElement('img');

    if(onLoadedFunction!==null) {
        lightbulb.addEventListener('load', () => {
            if (lightbulb.src && lightbulb.src !== "about:blank" && lightbulb.src !== null) {
                onLoadedFunction();
            }
        });
    }

    previewContent.setOnLoadedImage = (onLoadedFunction) => setOnLoadedImage(lightbulb, onLoadedFunction);

    lightbulb.src = '/images/idea/idea-lightbulb.webp';
    lightbulb.classList.add("idea-preview-content-lightbulb");

    /*
    const explosionMono = document.createElement('img');
    explosionMono.src = '/images/idea/idea-explosion-mono.png';
    explosionMono.classList.add("idea-preview-content-explosion");
    */

    const ideaCaption = document.createElement('p');
    ideaCaption.innerText = 'An idea';

    previewContentImageBox.append(lightbulb);
    //previewContentImageBox.append(explosionMono);

    previewContent.append(previewContentImageBox, ideaCaption);
    previewContent.lightbulb = lightbulb;

    return previewContent;
    
}

function youtubeMethodInit(preview, onLoadedFunction) {
    const previewUrl = `https://www.youtube.com/embed/${preview.videoId}?feature=oembed`;
    const previewContent = document.createElement('iframe');
    previewContent.classList.add("youtube-preview-content");
    
    if(onLoadedFunction!==null) {  
        previewContent.addEventListener('load', () => {
            if (previewContent.src && previewContent.src !== "about:blank" && previewContent.src !== null) {
                onLoadedFunction();
            }
        });
    }

    previewContent.setOnLoadedIframe = (onLoadedFunction) => setOnLoadedIframe(previewContent, onLoadedFunction);
            
    previewContent.src = previewUrl;

    return previewContent;
}

function soundCloudMethodInit(preview, onLoadedFunction) {
    console.log("trackId "+preview.trackId);
    
    const previewUrl = `https://w.soundcloud.com/player/?visual=true&url=${encodeURIComponent(`https://api.soundcloud.com/tracks/${preview.trackId}`)}&show_artwork=true`;
    const previewContent = document.createElement('iframe');
    previewContent.classList.add("soundcloud-preview-content");

    if(onLoadedFunction!==null) {
        previewContent.addEventListener('load', () => {
            if (previewContent.src && previewContent.src !== "about:blank" && previewContent.src !== null) {
                onLoadedFunction();
            }
        });
    }

    previewContent.setOnLoadedIframe = (onLoadedFunction) => setOnLoadedIframe(previewContent, onLoadedFunction);
            
    previewContent.src = previewUrl;

    return previewContent;
}

function imageFileMethodInit(preview, onLoadedFunction) {
    const previewPath = preview.key;
    const previewFile = document.createElement('img');
    previewFile.classList.add("image-preview-content");

    if(onLoadedFunction!==null) {
        previewFile.addEventListener('load', () => {
            if (previewFile.src && previewFile.src !== "about:blank" && previewFile.src !== null) {
                onLoadedFunction();
            }
        });
    }

    previewFile.setOnLoadedImage = (onLoadedFunction) => setOnLoadedImage(previewFile, onLoadedFunction);
            
    insertImageValue(previewFile, previewPath);

    return previewFile;

}

function pdfFileMethodInit(preview) {

}

function setOnLoadedIframe(iframe, onLoadedFunction) {
    if(!(onLoadedFunction instanceof Function))
        throw new Error('Must be function!');

    iframe.addEventListener('load', () => {
        if (iframe.src && iframe.src !== "about:blank" && iframe.src !== null) {
            onLoadedFunction();
        }
    });
}

function setOnLoadedImage(img, onLoadedFunction) {
    if(!(onLoadedFunction instanceof Function))
        throw new Error('Must be function!');

    img.addEventListener('load', () => {
        if (img.src && img.src !== "about:blank" && img.src !== null) {
            onLoadedFunction();
        }
    });
}

function setOnLoadedIdea(ideaElement, onLoadedFunction) {
    if(!(onLoadedFunction instanceof Function))
        throw new Error('Must be function!');

    const lightbulb = ideaElement.lightbulb;

    lightbulb.addEventListener('load', () => {
        if (lightbulb.src && lightbulb.src !== "about:blank" && lightbulb.src !== null) {
            onLoadedFunction();
        }
    });
}